
import { GameMenu } from "@/gui";
import type { GUIListBox, GUILabel, GUIButton, GUIControl } from "@/gui";
import { ModuleItem } from "@/module";
import { GUIInventoryItem } from "@/gui/protoitem/GUIInventoryItem";
import { GameState } from "@/GameState";

/**
 * MenuInventory class.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file MenuInventory.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export class MenuInventory extends GameMenu {

  LB_ITEMS: GUIListBox;
  LBL_INV: GUILabel;
  LBL_CREDITS_VALUE: GUILabel;
  LBL_CREDITS: GUILabel;
  LB_DESCRIPTION: GUIListBox;
  LBL_BGPORT: GUILabel;
  LBL_BGSTATS: GUILabel;
  LBL_PORT: GUILabel;
  LBL_VIT: GUILabel;
  LBL_DEF: GUILabel;
  BTN_QUESTITEMS: GUIButton;
  BTN_CHANGE1: GUIButton;
  BTN_CHANGE2: GUIButton;
  BTN_USEITEM: GUIButton;
  BTN_EXIT: GUIButton;

  selected: ModuleItem;

  constructor(){
    super();
    this.gui_resref = 'inventory';
    this.background = '1600x1200back';
    this.voidFill = true;
  }

  async menuControlInitializer(skipInit: boolean = false) {
    await super.menuControlInitializer();
    if(skipInit) return;
    this.childMenu = this.manager.MenuTop;
    return new Promise<void>((resolve, reject) => {
      this.BTN_EXIT.addEventListener('click', (e) => {
        e.stopPropagation();
        this.close();
      });
      this._button_b = this.BTN_EXIT;

      this.LB_ITEMS.setProtoBuilder(GUIInventoryItem);
      this.LB_ITEMS.padding = 5;
      this.LB_ITEMS.onSelected = (item: ModuleItem) => {
        this.selected = item;
        this.UpdateSelected();
      }

      this.LB_ITEMS.padding = 5;
      this.LB_ITEMS.offset.x = 0;

      this.BTN_CHANGE1.addEventListener('click', (e) => {
        e.stopPropagation();
        if(GameState.PartyManager.party.length > 0){
          GameState.PartyManager.SwitchLeaderAtIndex(1);
        }
      });
      this.BTN_CHANGE2.addEventListener('click', (e) => {
        e.stopPropagation();
        if(GameState.PartyManager.party.length > 1){
          GameState.PartyManager.SwitchLeaderAtIndex(2);
        }
      });

      GameState.PartyManager.AddEventListener('change', () => {
        if(!this.isVisible()) return;
        this.updateCharacterStats();
      });
      resolve();
    });
  }

  UpdateSelected(){
    if(this.selected instanceof ModuleItem){
      this.LB_DESCRIPTION?.setItem(this.selected.getDescription());
    }
  }

  filterInventory(){
    const inv = GameState.InventoryManager.getNonQuestInventory();
    this.LB_ITEMS.setItems(inv);
  }

  updateCharacterStats(){
    const currentPC = GameState.PartyManager.party[0];
    if (!currentPC) {
      return;
    }
    this.LBL_VIT?.setText(currentPC.getHP() + '/' + currentPC.getMaxHP());
    this.LBL_DEF?.setText(currentPC.getAC());
    if(this.LBL_PORT.getFillTextureName() != currentPC.getPortraitResRef()){
      this.LBL_PORT.setFillTextureName(currentPC.getPortraitResRef());
    }
    this.LBL_CREDITS_VALUE.setText(GameState.PartyManager.Gold);
  }

  updatePartyMemberButtons(){
    this.BTN_CHANGE1?.hide();
    this.BTN_CHANGE2?.hide();
    for (let i = 0; i < GameState.PartyManager.party.length; i++) {
      if (i == 0) { continue; }

      const btn_change = this.getControlByName('BTN_CHANGE' + i);
      if(!btn_change){ continue; }

      const partyMember = GameState.PartyManager.party[i];
      if(!partyMember){ continue; }

      const portraitResRef = partyMember.getPortraitResRef();
      btn_change.show();
      if (btn_change.getFillTextureName() != portraitResRef) {
        btn_change.setFillTextureName(portraitResRef);
      }
    }
  }

  show() {
    super.show();
    this.manager.MenuTop.LBLH_INV.onHoverIn();
    this.selectedControl = this.LB_ITEMS;
    this.filterInventory();
    this.updateCharacterStats();
    this.updatePartyMemberButtons();
  }

  triggerControllerBumperLPress() {
    this.manager.MenuTop.BTN_EQU.click();
  }

  triggerControllerBumperRPress() {
    this.manager.MenuTop.BTN_CHAR.click();
  }
  
}

